export const IMG_PREFIX =
  "https://images.nowpurchase.com/uploads/";

export const VIDEO_PREFIX =
  "https://images.nowpurchase.com/landing/";

export const imagePaths = {
  FinancingSolution: `${IMG_PREFIX}20240919110620_FinancingMainImg.png`,
  MarketPlaceMainImg: `${IMG_PREFIX}20240905052718_MarketPlaceMainImage.png`,
  MetalCloudAccuracy: `${IMG_PREFIX}20240905060054_MetalCloudSoftware_Accuracy.png`,
  MetalCloudAnalytics: `${IMG_PREFIX}20240905060032_MetalCloudSoftware_Analytics.png`,
  MetalCloudQualityReports: `${IMG_PREFIX}20240905055907_MetalCloudSoftware_QualityReport.png`,
  MetalCloudChargemix: `${IMG_PREFIX}20240905060008_MetalCloudSoftware_Chargemix.png`,
  MetalCloudIOT: `${IMG_PREFIX}20240905055941_MetalCloudSoftware_IOT.png`,
  MetalCloudWhatsapp: `${IMG_PREFIX}20240905055841_MetalCloudSoftware_Whatsapp.png`,
  MetalCloudSoftwareMainImg: `${IMG_PREFIX}20240915055637_MetalCloudMainContentImage.png`,
  ScrapProcessingMainImg: `${IMG_PREFIX}20240915060648_ScrapRecyclingMainContentImage.png`,
  PrivateLabelsMainImg: `${VIDEO_PREFIX}20260424030031_NEW%20(2).png`,
  // PrivateLabelsMobileMainImg: `${VIDEO_PREFIX}20251028141440_image_mobile_final.png`,
  PrivateLabelsMobileMainImg: `${IMG_PREFIX}20260422104029_FR MockUp for HomePage - Mobile Res.png`,
  TechSolutionsMainImg: `${IMG_PREFIX}20240905052846_TechSolutionsMainImage.png`,
  MarketPlaceVirginMetals: `${IMG_PREFIX}20240905054056_MarketPlace_VirginMetals.png`,
  MarketPlaceSand: `${IMG_PREFIX}20240905054122_MarketPlace_Sand.png`,
  MarketPlaceRefactoryItems: `${IMG_PREFIX}20240905054146_MarketPlace_RefactoryItems.png`,
  MarketPlacePigIron: `${IMG_PREFIX}20240905054210_MarketPlace_PigIron.png`,
  MarketPlaceNoduInoculant: `${IMG_PREFIX}20240905054351_MarketPlace_NoduInoculant.png`,
  MarketPlaceMetalScrap: `${IMG_PREFIX}20240905054424_MarketPlace_MetalScrap.png`,
  MarketPlaceFerroAlloys: `${IMG_PREFIX}20240905054454_MarketPlace_FerroAlloys.png`,
  MarketPlaceCarbonAdditives: `${IMG_PREFIX}20240905054528_MarketPlace_CarbonAdditives.png`,
  ScrapRecyclingSegregation: `${IMG_PREFIX}20240905055243_ScrapRecycling_Segregation.png`,
  ScrapRecyclingHighQualityScrap: `${IMG_PREFIX}20240905055318_ScrapRecycling_HighQualityScrap.png`,
  ScrapRecycling_Acquistion: `${IMG_PREFIX}20240905055342_ScrapRecycling_Acquistion.png`,
  ScrapRecyclingTestedQualityScrap: `${IMG_PREFIX}20240905065920_ScrapRecycling_TestedQualityScrap.png`,
  TechSolutions_Prices: `${IMG_PREFIX}20240905060437_TechSolutions_Prices.png`,
  FinancingSolutionSupplierIcon: `${IMG_PREFIX}20240918091254_supplychain.png`,
  FinancingSolutionRelationIcon: `${IMG_PREFIX}20240918091227_relation.png`,
  FinancingSolutionConsultationIcon: `${IMG_PREFIX}20240918093021_consultation.png`,
  FinancingSolutionContactIcon: `${IMG_PREFIX}20240918091202_contactdetails.png`,
  FundingMainImage: `${IMG_PREFIX}20240919055722_FundingMainImg.jpeg`,
  RealGroupLogo: `${IMG_PREFIX}20240919083222_RealGroupLogo.png`,
  AmtaunitImg: `${IMG_PREFIX}20240919094055_AmtaImg.png`,
  CareerSectionVideo: `${VIDEO_PREFIX}OfficeCultureVideo.mp4`,
  ScrapRecyclingVideo: `${IMG_PREFIX}PU+Teaser.mp4`,
  InoculantImg: `${VIDEO_PREFIX}20241220070000_InoculantImg.png`,
  NobleFerroAlloysImg: `${VIDEO_PREFIX}20241220070000_NobleFerroAlloysImg.png`,
  IFEX2025: `${VIDEO_PREFIX}20250221095706_IFEX 2025.jpg`,
  MonitorOperations: `${IMG_PREFIX}20250728062104_monitor_operations.png`,
  ReduceDowntime: `${IMG_PREFIX}20250728062104_downtime_reduction.png`,
  AILedInsights: `${IMG_PREFIX}20250728062104_insights.png`,
  DefectBot: `${IMG_PREFIX}20250728062105_Whatsapp_icon.png`,
  DefectReduction: `${IMG_PREFIX}20250728062104_defects_reduction.png`,
  ConsitentQuality: `${IMG_PREFIX}20250728062105_quality.png`,
  // AIMainImage: `${IMG_PREFIX}20250728074450_AIMainImage.png`,
  AIMainImage: `${IMG_PREFIX}20260408081337_aiMain.png`,
  EnergyConsump: `${IMG_PREFIX}20250728103625_energy_consumption.png`,
  AIDefect: `${IMG_PREFIX}20250728103624_ai_defect.png`,
  Shopfloor: `${IMG_PREFIX}20260408075844_shopfloor.png`,
  Throughput: `${IMG_PREFIX}20260408080031_Throughput.png`,
  BIFW_2025: `${VIDEO_PREFIX}20260422073012_BIFW 2025.jpeg`,
  IFFE_2025: `${IMG_PREFIX}20260422073917_IFFE 2025.jpeg`,
  NP_Shiroli: `${IMG_PREFIX}20260422073922_NP Shiroli Premier League.jpeg`,
  IMRC_2026: `${IMG_PREFIX}20260422073922_IMRC 2026.jpeg`,
  IIF: `${IMG_PREFIX}IIF+Foundry+Conclave%2C+TN+2025.jpg`,
  IFEX_2026: `${IMG_PREFIX}IFEX+2026+(1).jpg`,
  Amiya_Paul: `${VIDEO_PREFIX}20260423084415_Amiya Paul (NowPlayer JAS'25).png`,
  Kanishk_Sharma: `${IMG_PREFIX}20260720161701_KanishkSharma_NowPlayer.jpg`
};
export const culturalValues = [
  {
    title: "Accountability",
    description:
      "We take ownership of our actions & uphold the highest ethical standards.",
    imgSrc: `${VIDEO_PREFIX}20250402072223_Accountability.svg`,
  },
  {
    title: "Collaboration",
    description:
      "We value diverse perspectives & work together to achieve better outcomes.",
    imgSrc: `${VIDEO_PREFIX}20250402072223_Collaboration.svg`,
  },
  {
    title: "Empathy",
    description:
      "We lead with compassion & take responsibility for the impact of our decisions.",
    imgSrc: `${VIDEO_PREFIX}20250402072224_Empathy.svg`,
  },
  {
    title: "Innovation",
    description:
      "We embrace bold ideas & challenge the status quo through shared vision & creativity.",
    imgSrc: `${VIDEO_PREFIX}20250402072224_Innovation.svg`,
  },
  {
    title: "Teamwork",
    description:
      "We build trust & unity, succeeding together through shared goals & collaboration.",
    imgSrc: `${VIDEO_PREFIX}20250402072224_Teamwork.svg`,
  },
];

export const servicesTabList = [
  {
    name: (
      <>
        AI <br />
        Enabled
      </>
    ),
    icon: "20250728054243_Artificial Intelligence.png",
  },
  {
    name: (
      <>
        Managed <br />
        MarketPlace
      </>
    ),
    icon: "20240822073934_market-place-active.png",
  },
  {
    name: (
      <>
        Scrap <br /> Recycling
      </>
    ),
    icon: "20240822073638_processed-scrap-active.png",
  },
  {
    name: (
      <>
        Flagship <br /> Range
      </>
    ),
    icon: "20240905092657_SignatureRangeIcon.png",
  },
  {
    name: (
      <>
        MetalCloud <br /> Platform
      </>
    ),
    icon: "20240822073817_metal-cloud-active.png",
  },
  {
    name: (
      <>
        Tech <br /> Enabled
      </>
    ),
    icon: "20240822074032_tech-solution-active.png",
  },
  {
    name: (
      <>
        Financing
        <br />
        Solution
      </>
    ),
    icon: "20240822074240_finance-solution-active.png",
  },
];

export const metalCloudTabs = [
  {
    text: (
      <>
        Live Heat Data on <strong>WhatsApp</strong>
      </>
    ),
    icon: imagePaths.MetalCloudWhatsapp,
  },
  {
    text: (
      <>
        Optimise <strong>ChargeMix with AI</strong>
      </>
    ),
    icon: imagePaths.MetalCloudChargemix,
  },
  {
    text: (
      <>
        Auto-Generate <strong>Quality Certificates</strong> for OEMs 95%
      </>
    ),
    icon: imagePaths.MetalCloudQualityReports,
  },
  {
    text: (
      <>
        <strong>Digitize Heat Plans</strong> for Factories
      </>
    ),
    icon: imagePaths.MetalCloudAnalytics,
  },
  {
    text: (
      <>
        Track and Analyze <strong>Energy Consumption</strong>
      </>
    ),
    icon: imagePaths.EnergyConsump,
  },
  {
    text: (
      <>
        Train Your Own AI to <strong>Spot Defects</strong>
      </>
    ),
    icon: imagePaths.AIDefect,
  },
];

export const metalCloudMobileTab = [
  {
    text: (
      <>
        Live Heat Data <br /> on <strong>WhatsApp</strong>
      </>
    ),
    icon: imagePaths.MetalCloudWhatsapp,
    alignment: "row",
  },
  {
    text: (
      <>
        Optimise <strong>ChargeMix with AI</strong>
      </>
    ),
    icon: imagePaths.MetalCloudChargemix,
    alignment: "row",
  },
  {
    text: (
      <>
        Auto-Generate <strong>Quality Certificates</strong> for OEMs 95%
      </>
    ),
    icon: imagePaths.MetalCloudQualityReports,
    alignment: "row",
  },
  {
    text: (
      <>
        <strong>Digitize Heat Plans</strong> for Factories
      </>
    ),
    icon: imagePaths.MetalCloudAnalytics,
    alignment: "row",
  },
  {
    text: (
      <>
        Track and Analyze <strong>Energy Consumption</strong>
      </>
    ),
    icon: imagePaths.EnergyConsump,
    alignment: "row",
  },
  {
    text: (
      <>
        Train Your Own AI to <strong>Spot Defects</strong>
      </>
    ),
    icon: imagePaths.AIDefect,
    alignment: "row",
  },
];

export const ScrapRecyclingTabImages = [
  {
    text: (
      <>
        Robust <strong>Sourcing Network</strong>
      </>
    ),
    icon: imagePaths.ScrapRecycling_Acquistion,
  },
  {
    text: (
      <>
        50,000 sq. ft. <strong>Processing Hub</strong>
      </>
    ),
    icon: imagePaths.ScrapRecyclingHighQualityScrap,
  },
  {
    text: (
      <>
        Advanced Scrap <strong>Processing Machinery</strong>
      </>
    ),
    icon: imagePaths.ScrapRecyclingSegregation,
  },
  {
    text: (
      <>
        <strong>Tested & Certified</strong> Scrap Delivery
      </>
    ),
    icon: imagePaths.ScrapRecyclingTestedQualityScrap,
  },
];

export const MarketPlaceTabImages = [
  {
    id: "metal-scrap",
    text: (
      <>
        Metal <br /> Scrap
      </>
    ),
    icon: imagePaths.MarketPlaceMetalScrap,
  },
  {
    id: "nodularizers",
    text: <>Nodularizers</>,
    icon: imagePaths.MarketPlaceNoduInoculant,
  },
  {
    id: "ferro-alloys",
    text: (
      <>
        Ferro <br /> Alloys
      </>
    ),
    icon: imagePaths.MarketPlaceFerroAlloys,
  },

  {
    id: "pig-iron",
    text: (
      <>
        Pig <br /> Iron
      </>
    ),
    icon: imagePaths.MarketPlacePigIron,
  },
  {
    id: "carbon-additives",
    text: (
      <>
        Carbon <br /> Additives
      </>
    ),
    icon: imagePaths.MarketPlaceCarbonAdditives,
  },
  {
    id: "inoculant",
    text: <>Inoculants</>,
    icon: imagePaths.InoculantImg,
  },
  {
    id: "noble-ferro-alloys",
    text: (
      <>
        Noble Ferro <br /> Alloys
      </>
    ),
    icon: imagePaths.NobleFerroAlloysImg,
  },
  {
    id: "virgin-metals",
    text: (
      <>
        Virgin Metals & <br /> Foundry <br /> Essentials
      </>
    ),
    icon: imagePaths.MarketPlaceVirginMetals,
  },
];

export const MarketPlaceMobileTabImages = [
  {
    id: "metal-scrap",
    text: (
      <>
        Metal <br /> Scrap
      </>
    ),
    icon: imagePaths.MarketPlaceMetalScrap,
  },
  {
    id: "nodularizers",
    text: <>Nodularizers</>,
    icon: imagePaths.MarketPlaceNoduInoculant,
    alignment: "row",
  },
  {
    id: "ferro-alloys",
    text: (
      <>
        Ferro <br /> Alloys
      </>
    ),
    icon: imagePaths.MarketPlaceFerroAlloys,
  },
  {
    id: "pig-iron",
    text: (
      <>
        Pig <br /> Iron
      </>
    ),
    icon: imagePaths.MarketPlacePigIron,
  },
  {
    id: "carbon-additives",
    text: (
      <>
        Carbon <br /> Additives
      </>
    ),
    icon: imagePaths.MarketPlaceCarbonAdditives,
    alignment: "row",
  },
  {
    id: "inoculant",
    text: <>Inoculants</>,
    icon: imagePaths.InoculantImg,
    alignment: "row",
  },
  {
    id: "noble-ferro-alloys",
    text: (
      <>
        Noble Ferro <br /> Alloys
      </>
    ),
    icon: imagePaths.NobleFerroAlloysImg,
  },
  {
    id: "virgin-metals",
    text: (
      <>
        Virgin Metals & <br /> Foundry <br /> Essentials
      </>
    ),
    icon: imagePaths.MarketPlaceVirginMetals,
    alignment: "row",
  },
];

export const TechSolutionsTabImages = [
  {
    text: (
      <>
        <strong>Track Your Orders</strong> in Real-Time
      </>
    ),
    icon: imagePaths.ScrapRecyclingTestedQualityScrap,
  },
  {
    text: (
      <>
        <strong>AI-powered</strong> Instant Price <strong>Updates</strong>
      </>
    ),
    icon: imagePaths.TechSolutions_Prices,
  },
  {
    text: (
      <>
        <strong>24-Hour IoT Integration</strong> for Optimised Melting
      </>
    ),
    icon: imagePaths.MetalCloudIOT,
  },
  {
    text: (
      <>
        <strong>WhatsApp Bot</strong> for Sales Support
      </>
    ),
    icon: imagePaths.MetalCloudWhatsapp,
  },
];

export const FinancingSolutionsTabImages = [
  {
    text: (
      <>
        <strong>Comprehensive</strong> Debt Advisory
      </>
    ),
    icon: imagePaths.FinancingSolutionConsultationIcon,
  },
  {
    text: (
      <>
        Streamlined <strong>Supply Chain</strong> Solutions
      </>
    ),
    icon: imagePaths.FinancingSolutionSupplierIcon,
  },
  {
    text: (
      <>
        Improved <strong>Supplier</strong> Relations
      </>
    ),
    icon: imagePaths.FinancingSolutionRelationIcon,
  },
  {
    text: (
      <>
        <strong>Expert-crafted</strong> Personalized Solutions
      </>
    ),
    icon: imagePaths.FinancingSolutionContactIcon,
  },
];

/* Finance partners shown in the "Financial Flexibility" tab panel
   (Figma 7551:5198 > Group 889795). Six 180px circles in a 3x2 grid; `box` is
   each logo's own size within its circle, per the design. */
export const FinancePartnerLogos = [
  // These live under /landing/, which is where the asset uploader writes —
  // IMG_PREFIX points at /uploads/ and would 403 for them.
  {
    name: "Tap",
    src: `${VIDEO_PREFIX}20260929063354_fin-tap.webp`,
    box: { width: "59.3%", height: "22.8%" },
  },
  {
    name: "Tata Capital",
    src: `${VIDEO_PREFIX}20260929063354_fin-tata-capital.webp`,
    box: { width: "70.6%", height: "17.2%" },
  },
  {
    name: "Mizuho",
    src: `${VIDEO_PREFIX}20260929063354_fin-mizuho.webp`,
    box: { width: "67.2%", height: "27.2%" },
  },
  {
    name: "Northern Arc",
    src: `${VIDEO_PREFIX}20260929063354_fin-northern-arc.webp`,
    box: { width: "60.6%", height: "34.4%" },
  },
  {
    name: "ICICI Bank",
    src: `${VIDEO_PREFIX}20260929063353_fin-icici.webp`,
    box: { width: "74.4%", height: "17.2%" },
  },
  {
    name: "indifi",
    src: `${VIDEO_PREFIX}20260929063353_fin-indifi.webp`,
    box: { width: "64.4%", height: "21.1%" },
  },
];

export const AIEnabledTabImages = [
  {
    text: (
      <>
        Make Shopfloor Activity<strong> Data-Driven</strong> 
      </>
    ),
   
    icon: imagePaths.ReduceDowntime,
  },
  {
    text: (
      <>
        <strong>Data Deviations</strong> via Data & Camera Feeds
      </>
    ),
    icon: imagePaths.MonitorOperations
  },
  {
    text: (
      <>
        <strong>Engineered Decisions</strong> Over Guesswork
      </>
    ),
    icon: imagePaths.AILedInsights,
  },
  {
    text: (
      <>
        <strong>+3% Throughput</strong> Increase
      </>
    ),
    icon: imagePaths.Throughput,
  },
  {
    text: (
      <>
        <strong>~95% Reduction</strong> in Alloy Waste
      </>
    ),
    icon: imagePaths.DefectReduction,
  },
  {
    text: (
      <>
         <strong>50% Faster</strong> Shopfloor Decisions
      </>
    ),
    icon: imagePaths.Shopfloor,
  },
];
